import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  memberSubscriptionInvoiceList: { loading: false, data: null, error: null },
  memberSubscriptionInvoiceCreate: { loading: false, data: null, error: null },
  memberSubscriptionApproveReject: { loading: false, data: null, error: null },
  memberSubscriptionGetById: { loading: false, data: null, error: null },

  memberList: { loading: false, data: null, error: null },
  subscriptionPackageList: { loading: false, data: null, error: null },
};

export const MemberSubscriptionInvoiceSlice = createSlice({
  name: "memberSubscriptionInvoice",
  initialState,
  reducers: {
    // MemberSubscriptionInvoice fetch List
    fetchMemberSubscriptionInvoiceListRequest: (state, action) => {
      state.memberSubscriptionInvoiceList.loading = true;
      state.memberSubscriptionInvoiceList.error = null;
    },
    fetchMemberSubscriptionInvoiceListSuccess: (state, action) => {
      state.memberSubscriptionInvoiceList.data = action.payload;
      state.memberSubscriptionInvoiceList.loading = false;
      state.memberSubscriptionInvoiceList.error = null;
    },
    fetchMemberSubscriptionInvoiceListFailure: (state, action) => {
      state.memberSubscriptionInvoiceList.data = null;
      state.memberSubscriptionInvoiceList.loading = false;
      state.memberSubscriptionInvoiceList.error = action.payload;
    },

    // MemberSubscriptionInvoice create
    createMemberSubscriptionInvoiceRequest: (state, action) => {
      state.memberSubscriptionInvoiceCreate.loading = true;
      state.memberSubscriptionInvoiceCreate.error = null;
    },
    createMemberSubscriptionInvoiceSuccess: (state, action) => {
      state.memberSubscriptionInvoiceCreate.data = action.payload;
      state.memberSubscriptionInvoiceCreate.loading = false;
      state.memberSubscriptionInvoiceCreate.error = null;
      state.memberSubscriptionInvoiceList =
        addNewMemberSubscriptionInvoiceSuccess(action.payload, {
          ...state.memberSubscriptionInvoiceList,
        });
    },
    createMemberSubscriptionInvoiceFailure: (state, action) => {
      state.memberSubscriptionInvoiceCreate.data = null;
      state.memberSubscriptionInvoiceCreate.loading = false;
      state.memberSubscriptionInvoiceCreate.error = action.payload;
    },

    // Approve - Reject
    memberSubscriptionChangeStatusRequest: (state, action) => {
      state.memberSubscriptionApproveReject.loading = true;
      state.memberSubscriptionApproveReject.error = null;
    },
    memberSubscriptionChangeStatusSuccess: (state, action) => {
      state.memberSubscriptionApproveReject.data = action.payload;
      state.memberSubscriptionApproveReject.loading = false;
      state.memberSubscriptionApproveReject.error = null;
    },
    memberSubscriptionChangeStatusFailure: (state, action) => {
      state.memberSubscriptionApproveReject.data = null;
      state.memberSubscriptionApproveReject.loading = false;
      state.memberSubscriptionApproveReject.error = action.payload;
    },

    // Member List
    fetchMemberListRequest: (state, action) => {
      state.memberList.loading = true;
      state.memberList.error = null;
    },
    fetchMemberListSuccess: (state, action) => {
      state.memberList.data = action.payload;
      state.memberList.loading = false;
      state.memberList.error = null;
    },
    fetchMemberListFailure: (state, action) => {
      state.memberList.data = null;
      state.memberList.loading = false;
      state.memberList.error = action.payload;
    },

    // Subscription Package List
    fetchSubscriptionPackageListRequest: (state, action) => {
      state.subscriptionPackageList.loading = true;
      state.subscriptionPackageList.error = null;
    },
    fetchSubscriptionPackageListSuccess: (state, action) => {
      state.subscriptionPackageList.data = action.payload;
      state.subscriptionPackageList.loading = false;
      state.subscriptionPackageList.error = null;
    },
    fetchSubscriptionPackageListFailure: (state, action) => {
      state.subscriptionPackageList.data = null;
      state.subscriptionPackageList.loading = false;
      state.subscriptionPackageList.error = action.payload;
    },

    // get by id
    fetchMemberSubscriptionInvoiceByIdRequest: (state, action) => {
      state.memberSubscriptionGetById.loading = true;
      state.memberSubscriptionGetById.error = null;
    },
    fetchMemberSubscriptionInvoiceByIdSuccess: (state, action) => {
      state.memberSubscriptionGetById.data = action.payload;
      state.memberSubscriptionGetById.loading = false;
      state.memberSubscriptionGetById.error = null;
    },
    fetchMemberSubscriptionInvoiceByIdFailure: (state, action) => {
      state.memberSubscriptionGetById.data = null;
      state.memberSubscriptionGetById.loading = false;
      state.memberSubscriptionGetById.error = action.payload;
    },
  },
});

// addNewMemberSubscriptionInvoice  Function
function addNewMemberSubscriptionInvoiceSuccess(dataToUpdate, state) {
  state.data.data = [dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}

export const {
  fetchMemberSubscriptionInvoiceListRequest,
  fetchMemberSubscriptionInvoiceListSuccess,
  fetchMemberSubscriptionInvoiceListFailure,
  createMemberSubscriptionInvoiceRequest,
  createMemberSubscriptionInvoiceSuccess,
  createMemberSubscriptionInvoiceFailure,
  memberSubscriptionChangeStatusRequest,
  memberSubscriptionChangeStatusSuccess,
  memberSubscriptionChangeStatusFailure,
  fetchMemberSubscriptionInvoiceByIdRequest,
  fetchMemberSubscriptionInvoiceByIdSuccess,
  fetchMemberSubscriptionInvoiceByIdFailure,

  fetchMemberListRequest,
  fetchMemberListSuccess,
  fetchMemberListFailure,
  fetchSubscriptionPackageListRequest,
  fetchSubscriptionPackageListSuccess,
  fetchSubscriptionPackageListFailure,
} = MemberSubscriptionInvoiceSlice.actions;

export const getMemberSubscriptionInvoiceListState = (store) =>
  store.memberSubscriptionInvoice?.memberSubscriptionInvoiceList;
export const getMemberSubscriptionChangeStatusState = (state) =>
  state.memberSubscriptionInvoice?.memberSubscriptionApproveReject;
export const getMemberSubscriptionInvoiceByIdState = (store) =>
  store.memberSubscriptionInvoice?.memberSubscriptionGetById;

export const getMemberListState = (store) =>
  store.memberSubscriptionInvoice?.memberList;

export const getSubscriptionPackageListState = (store) =>
  store.memberSubscriptionInvoice?.subscriptionPackageList;

export default MemberSubscriptionInvoiceSlice.reducer;
